import { Input } from "antd";
import React, { useState, useEffect } from "react";
import { currencySymbol } from "../../utils/currency";

interface PriceInputProps {
  value: number; // wartość w groszach
  onChange: (cents: number) => void; // callback zwracający grosze
  editMode: boolean;
  width?: string;
  form?: any;
  id?: any;
  currency?: string;
}

export const PriceInput: React.FC<PriceInputProps> = ({
  value,
  onChange,
  editMode,
  width,
  currency,
}) => {
  const symbol = currencySymbol(currency);
  const [inputValue, setInputValue] = useState<any>(
    value > 0 ? (value / 100).toFixed(2) : ""
  ); // zł format

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(",", "."); // Zamiana przecinka na kropkę
    setInputValue(newValue);

    const parsedValue = parseFloat(newValue);
    if (!isNaN(parsedValue)) {
      onChange(Math.round(parsedValue * 100)); // Konwersja na grosze
    }
  };

  const [firstRender, setFirstRender] = useState<any>(false); // zł format

  // useEffect(() => {
  //   if (firstRender) setInputValue((value / 100).toFixed(2));
  //   setFirstRender(true)
  // }, [value]);

  if (editMode)
    return (
      <>
        <Input
          type="text"
          value={inputValue}
          onChange={handleChange}
          onBlur={() => setInputValue((value / 100).toFixed(2))} // Reset formatu po wyjściu
          style={{
            padding: "5px",
            fontSize: "16px",
            width: width ? width : "150px",
            textAlign: "right",
          }}
          styles={{
            input: {
              borderTopRightRadius: '0px !important',
              borderBottomRightRadius: '0px !important',
              borderRight: '0 !important',
            },
          }}
          className="price-input-with-addon"
          addonAfter={symbol}
          placeholder="0.00"
        />
      </>
    );

  return <>{(value / 100).toFixed(2)} {symbol}</>;
};
